import React from 'react';
import { Line } from 'react-chartjs-2';
import TrafficLight from '../../components/TrafficLight/TrafficLight';
import { chartOptions,  } from './config/ChartOptions'; 
import styles from './Index.module.css';
import Camera from '../camera/Index';
import { Link } from 'react-router-dom';
import ChartProps from './types/chartProps'
import { useTranslation } from 'react-i18next'; 

const Chart: React.FC<ChartProps> = ({ chartData, deviceId, dateFilter }) => {  
    const { t: translateDash } = useTranslation("dashboard");

    return (
        <div className={styles.chartContainer}>
            <div className={styles.chartbox}>
                <div className={styles.ChartTitleBox}>
                    <span className={styles.ChartTitle}>{translateDash("eventDistribution")}</span>
                </div>
                
                <Line data={chartData} options={chartOptions} />
            </div>
            <div className={styles.TrafficLightContiner}>
                <div className={styles.TrafficLightTitle}>{translateDash("trafficLight")}</div>
                <TrafficLight deviceId={deviceId} dateFilter={dateFilter}/>
                <div className={styles.CameraTitle}>{translateDash("camera")}</div>
                <Link to="#" aria-label={translateDash("camera")}>
                    <Camera />
                </Link> 
            </div>
        </div>
    );
};

export default Chart;
